import React from "react";
import mock07 from "../assets/images/mock07.png";
import mock08 from "../assets/images/mock08.png";
import mock09 from "../assets/images/mock09.png";
import mock10 from "../assets/images/mock10.png";
import "../assets/styles/Project.scss";

function Project() {
  return (
    <div className="projects-container" id="projects">
      <h1>PERSONAL PROJECTS</h1>
      <div className="projects-grid">
        <div className="project">
          <a
            href="https://futuretech.gomemezone.com/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={mock10} className="zoom" alt="thumbnail" width="100%" />
          </a>
          <a
            href="https://futuretech.gomemezone.com/"
            target="_blank"
            rel="noreferrer"
          >
            <h2>Future Tech</h2>
          </a>
          <p>
            Future Tech explores emerging technologies shaping the next
            generation of data, AI, cloud platforms, and digital innovation. It
            highlights trends, tools, and ideas that drive scalable systems,
            intelligent analytics, and modern data-driven solutions.
          </p>
        </div>
        <div className="project">
          <a
            href="https://www.vaniday.com/index.php/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={mock09} className="zoom" alt="thumbnail" width="100%" />
          </a>
          <a
            href="https://www.vaniday.com/index.php/"
            target="_blank"
            rel="noreferrer"
          >
            <h2>Vaniday</h2>
          </a>
          <p>
            Vaniday is the trusted platform to browse, book and buy beauty and
            wellness treats. It is the place to find and book beauty, wellness
            and fitness experiences online.
          </p>
        </div>
        <div className="project">
          <a
            href="https://www.eventssmarter.com/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={mock08} className="zoom" alt="thumbnail" width="100%" />
          </a>
          <a
            href="https://www.eventssmarter.com/"
            target="_blank"
            rel="noreferrer"
          >
            <h2>Event Smarter</h2>
          </a>
          <p>
            Their platform helps organizations handle things like event
            registration, ticketing, check-ins, and attendee management. It’s
            mainly used by companies and organizations that want to run events
            in a more organized and efficient way.
          </p>
        </div>
        <div className="project">
          <a href="https://quicktutor.com/" target="_blank" rel="noreferrer">
            <img src={mock07} className="zoom" alt="thumbnail" width="100%" />
          </a>
          <a href="https://quicktutor.com/" target="_blank" rel="noreferrer">
            <h2>QuickTutor</h2>
          </a>
          <p>
            It helps people find one-to-one tutoring sessions for different
            subjects in a simple and direct way. The goal is to make learning
            easier by matching students with the right tutors online.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Project;
